<template>
  <b-table
    :tbody-tr-class="tbodyTrClass"
    :items="hinder.days"
    :fields="['Dag', 'Hinder', 'Bevestigd']"
    foot-clone
    caption="In deze tabel kan de feitelijke hinder per dag worden aangepast."
    caption-top
    select-mode="single"
    selectable
    small
    @row-selected="onSelectedHinder"
  >
    <template #cell(Hinder)="row">
      <hinder-input v-model="row.item.hinder" />
    </template>

    <template #cell(Dag)="row">
      {{
        moment(hinder.start).add(row.item.index, "days").format("ddd DD MMM YY")
      }}
    </template>

    <template 
      #cell(Bevestigd)="row" 
      style="text-align: center"
    >
      <b-checkbox v-model="row.item.bevestigd" />
    </template>
    <template #foot(Hinder)>
      <b-button
        v-if="standaardhinder != null"
        variant="warning"
        size="sm"
        @click="copyStandaard"
      >
        Alle dagen is hinder zoals op
        {{
          moment(hinder.start)
            .add(standaardhinder.index, "days")
            .format("ddd DD MMM YY")
        }}
      </b-button>
    </template>
  </b-table>
</template>
<script>
import HinderInput from './HinderInput.vue';
export default {
  name: "HinderDetails",
  components: {HinderInput},
  mixins: [],
  props: {
      hinder: {
          type: Object,
          default: () => {
              return {
                days: [],
                start: null,
                eind: null
              }
          }
      }
  },
  data() {
    return {
      standaardhinder: null,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    tbodyTrClass(item, type) {
      if (type == "row-details") return "bg-gray-500";
      var dow = this.moment(this.hinder.start).add(item.index, "days").day();
      //if (item._showDetails) return "bg-dark";
      if (dow == 0 || dow == 6) return "bg-gray-600";
      return null;
    },
    onSelectedHinder(rows) {
      console.log(rows);
      this.standaardhinder = rows[0];
    },
    copyStandaard() {
      this.hinder.days.forEach(day => {
        day.hinder = [...this.standaardhinder.hinder]
      });
    },
  },
};
</script>